// extracted by mini-css-extract-plugin
export default {"mainDiv":"ButtonCompo_mainDiv__-2vYm","mainBtn":"ButtonCompo_mainBtn__nY5Sx","disabled":"ButtonCompo_disabled__XdnKm"};